import { render, staticRenderFns } from "./future.vue?vue&type=template&id=0756be50&scoped=true"
import script from "./future.vue?vue&type=script&lang=js"
export * from "./future.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0756be50",
  null
  
)

export default component.exports